import React, { useCallback, useMemo } from "react";

export default function FishMultiFilter({ fishList, selectedIds, onChange, label }) {
    const selectedSet = useMemo(() => new Set(selectedIds.map(Number)), [selectedIds]);

    const toggleFish = useCallback((fishId) => {
        const id = Number(fishId);
        if (!Number.isFinite(id) || id <= 0) return;
        const next = new Set(selectedSet);
        if (next.has(id)) next.delete(id);
        else next.add(id);
        onChange(Array.from(next).sort((a, b) => a - b));
    }, [onChange, selectedSet]);

    return (
        <div className="filter-field fish-multi-filter">
            <div className="fish-multi-filter__head">
                <label className="fish-multi-filter__label">{label}</label>
            </div>
            <div className="fish-multi-filter__list" role="group" aria-label={label}>
                {fishList.map((fish) => (
                    <label key={fish.id} className="map-filters__check fish-multi-filter__item">
                        <input
                            type="checkbox"
                            checked={selectedSet.has(Number(fish.id))}
                            onChange={() => toggleFish(fish.id)}
                        />
                        <span>{fish.name}</span>
                    </label>
                ))}
            </div>
            {selectedIds.length > 0 && (
                <p className="fish-multi-filter__hint">
                    Выбрано: {selectedIds.length}
                </p>
            )}
        </div>
    );
}
